import { Button, IconButton, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { capitalizeLabel } from "./calendar";
import { DayPane, DayRow, MonthBar } from "./theme";

export default function ActivityDayList({
  activityCounts,
  canAdd,
  canGoNext,
  days,
  monthLabel,
  onAdd,
  onNextMonth,
  onPreviousMonth,
  onSelect,
  selectedDate,
}) {
  return (
    <DayPane>
      <MonthBar>
        <IconButton aria-label="Mese precedente" onClick={onPreviousMonth} size="small">
          <ChevronLeftIcon fontSize="small" />
        </IconButton>
        <Typography component="span">{capitalizeLabel(monthLabel)}</Typography>
        <IconButton
          aria-label="Mese successivo"
          disabled={!canGoNext}
          onClick={onNextMonth}
          size="small"
        >
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      </MonthBar>
      {days.map((day) => {
        const count = activityCounts[day.date] || 0;
        const selected = day.date === selectedDate;
        return (
          <DayRow
            data-testid={`day-${day.date}`}
            data-date={day.date}
            data-selected={selected}
            data-weekend={day.isWeekend}
            key={day.date}
          >
            <Button data-day-select disableRipple onClick={() => onSelect(day.date)}>
              <span className="day-date">{capitalizeLabel(day.label)}</span>
              <span className="day-detail">
                {`${capitalizeLabel(day.weekday)} - Attività: ${count}`}
              </span>
            </Button>
            {selected && canAdd ? (
              <IconButton
                aria-label={`Aggiungi attività del ${capitalizeLabel(day.label)}`}
                className="day-add"
                onClick={onAdd}
                size="small"
              >
                <AddIcon fontSize="small" />
              </IconButton>
            ) : null}
          </DayRow>
        );
      })}
    </DayPane>
  );
}
